import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ICheckoutSectionProps } from "@crunchit/types";

import { useAppSelector } from "store/app";
import { useCheckoutSelector } from "store/checkout";
import { useBasketSelector } from "store/basket";

import SectionWrapper from "components/checkout/SectionWrapper";
import OrderList from "components/basket/OrderList/OrderList";
import Empty from "./Empty";
import ItemizedTotal from "components/basket/totals/ItemizedTotal";
import BagFeeCheckbox from "./BagFeeCheckbox";

import Discount from "./Discount";
import Giftcard from "./Giftcard";

import "./CheckoutBasket.scss";

export default function CheckoutBasket(props: ICheckoutSectionProps) {
  const { index } = props;

  const { module, isFasttrack } = useAppSelector();
  const { basketProducts, basketProductTotal, bagFeeProductId } = useBasketSelector({ allowCartFees: true });
  const { checkoutSession, checkout, checkoutInstanceSettings, getCheckoutPayments } = useCheckoutSelector();

  const { isDiscountEnabled, isGiftcardEnabled } = checkoutInstanceSettings;
  const { isDelivery, discount } = checkoutSession;

  const { t } = useTranslation();
  const redirect = useNavigate();

  let giftcardInBasket = useMemo(() => basketProducts.find((p) => p.isGiftcard) !== undefined, [basketProducts]);

  let showBringOwnBagCheckbox = useMemo(() => bagFeeProductId && !isDelivery, [bagFeeProductId, isDelivery]);

  const deliveryFee = (checkout.delivery && checkout.delivery.deliveryFee) || 0;
  const discountAmount = (discount && discount.amount) || 0;

  const payments = useMemo(() => getCheckoutPayments(), [getCheckoutPayments]);

  return basketProducts.length === 0 ? (
    <Empty handleButtonClick={() => redirect("/")} />
  ) : (
    <SectionWrapper index={index} title={t("checkout:Cart.Title")}>
      <OrderList products={basketProducts} />

      {showBringOwnBagCheckbox && <BagFeeCheckbox />}

      <ItemizedTotal orderTotal={basketProductTotal - discountAmount + deliveryFee} isDiscountEnabled={isDiscountEnabled} discountAmount={discountAmount} deliveryFee={deliveryFee} payments={payments} />

      {isDiscountEnabled && module.discountInstanceId && <Discount discountInstanceId={module.discountInstanceId} />}

      {isGiftcardEnabled && module.giftcardInstanceId && !giftcardInBasket && !isFasttrack && <Giftcard giftcardInstanceId={module.giftcardInstanceId} />}
    </SectionWrapper>
  );
}
